// Globals
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// Modules
import { DeleteFaqConfirmModal } from '@/modules/FaqCommon';

// Store
import { useAppDispatch, useAppState } from '@/store';
import { deleteFaqs, selectFaqsIsLoading } from '../feature';

type TBulkDeleteChannelFaqModalProps = {
  isOpen: boolean;
  onClose: () => void;
  channelId: number;
  chosenFaqIds: string[];
  resetSelection: () => void;
  onDeleted: () => void;
};

const BulkDeleteChannelFaqModal: FC<TBulkDeleteChannelFaqModalProps> = ({
  isOpen,
  onClose,
  channelId,
  chosenFaqIds,
  resetSelection,
  onDeleted,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const isLoading = useAppState(selectFaqsIsLoading);

  const handleBulkDeleteFaq = async () => {
    try {
      await dispatch(deleteFaqs({ channelId, faqIds: chosenFaqIds })).unwrap();
      onClose();
      resetSelection();
      onDeleted();
    } catch {}
  };

  return (
    <DeleteFaqConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleBulkDeleteFaq}
      isLoading={isLoading}
      title={t('bulk_delete_faq_confirm', { count: chosenFaqIds.length })}
      description={t('delete_description')}
    />
  );
};

export default BulkDeleteChannelFaqModal;
